<!-- Created by 337547038 on 2020/8/19 0019. -->
<template>
  <div class="news-page">
    <div class="search">
      <div class="form">
        <span>搜索 |</span>
        <input type="text" class="input-control" v-model="keyWord">
        <input type="button" class="btn" @click="init">
      </div>
    </div>
    <div class="main">
      <div class="bg">
        <div class="item tooltip" v-for="(item,index) in list" :key="index">
          <a :href="item.url" target="_blank"><img :src="item.img">
            <div class="text">{{item.name}}</div>
          </a>
        </div>
      </div>
      <div class="page">
        <a href="javascript:;" class="prev" @click="prevNext(0)"></a>
        <span>
         <a href="javascript:;"
            v-for="(item,index) in pageCount"
            :key="index"
            :class="{active:item===pageIndex}"
            @click="prevNext(item,'page')">{{item}}</a>
        </span>
        <a href="javascript:;" class="next" @click="prevNext(1)"></a>
      </div>
    </div>
  </div>
</template>

<script>
import {getBriefingList} from '@/api'

export default {
  name: "index",
  data() {
    return {
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      list: [],
      keyWord: ''
    }
  },
  props: {},
  components: {},
  methods: {
    init() {
      const data = {
        name: this.keyWord,
        pageNumber: this.pageIndex,
        pageSize: this.pageSize
      }
      getBriefingList(data)
      .then(res => {
        const result = res.data.data
        if (result) {
          this.list = result.list
          this.total = result.total
          setTimeout(() => {
            this.tooltip()
          }, 500)
        }
      })
    },
    tooltip() {
      const tooltip = document.querySelectorAll(".tooltip")
      tooltip.forEach((item) => {
        const a = item.querySelector('a')
        const text = item.querySelector('.text')
        a.onmouseover = function () {// 移进来显示
          text.style.display = "block"
        }
        a.onmouseout = function () {// 移出去消失
          text.style.display = "none"
          text.style.left = ''
          text.style.top = ''
        }
        a.onmousemove = function (eve) { // 跟着鼠标走
          var e = eve || window.event
          text.style.left = e.offsetX + 100 + "px"
          text.style.top = e.offsetY + 25 + this.offsetTop + "px"
        }
      })
    },
    prevNext(type, page) {
      if (page === 'page') {
        this.pageIndex = type
      } else if (type === 0) {
        // 上一页
        this.pageIndex--
      } else if (type === 1) {
        // 下一页
        this.pageIndex++
      }
      this.init()
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  mounted() {
    this.init()
  }
}
</script>
